var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.isActive ? 'active' : '',attrs:{"title":_vm.theDescription,"href":"#"},on:{"click":function($event){return _vm.redirectUser($event)}}},[_vm._v(_vm._s(_vm.theTitle))])}
var staticRenderFns = []

export { render, staticRenderFns }